import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { StockProviderListPage } from '../../../stock/stock-provider-list/stock-provider-list';
import { IncomeExpensesListPage } from '../../../income-expenses/income-expenses-list/income-expenses-list';
import { StockListPage } from '../../../stock/stock-list/stock-list';
import { CustomersListPage } from '../../../customers/customers-list/customers-list';
import { ArticlesListPage } from '../../../articles/articles-list/articles-list';
import { SalesListPage } from '../../../sales/sales-list/sales-list';


/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'page-import-finish',
  templateUrl: 'import-finish.html',
})
export class ImportFinishPage {
  type: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,) {

    this.type = this.navParams.get('type'); //Type to know if import Providers, Dishes, Products or Ingredients

  }
  openListProviders() {
    this.navCtrl.setRoot(StockProviderListPage);
  }

  openListDishes() {
    this.navCtrl.setRoot(ArticlesListPage);
  }

  openListIngredients() {
    this.navCtrl.setRoot(StockListPage);
  }

  openListProducts() {
    this.navCtrl.setRoot(ArticlesListPage);
  }

  openListIncomes() {
    this.navCtrl.setRoot(IncomeExpensesListPage);
  }

  openListExpenses() {
    this.navCtrl.setRoot(IncomeExpensesListPage);
  }

  openListCustomers() {
    this.navCtrl.setRoot(CustomersListPage);
  }

  openListSales() {
    this.navCtrl.setRoot(SalesListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/import-excel/import-finish/import-finish.ts